module.exports = "/assets/logo_sg_substance_3d_modeler-78826dc88aec1f33b61b88b36b41fe63.png";